module.exports = __webpack_public_path__ + "img/virtual_conference.71f9ad44.svg";